import React, { FC, useContext, useMemo } from 'react';
import { NikeRoute } from '../../common/routing/types';

interface BetbookProfileContextConfig {
    RequestNotificationPermission: React.FC;
    getBetbookPostsAuthorRoute: () => NikeRoute;
}
const EMPTY: BetbookProfileContextConfig = {
    RequestNotificationPermission: () => {
        console.error('RequestNotificationPermission should request notifications');
        return null;
    },
    getBetbookPostsAuthorRoute: () => {
        console.error('getBetbookPostsAuthorRoute should return route');
        return null;
    }
};

const BetbookProfileContext = React.createContext<BetbookProfileContextConfig>(EMPTY);

export const useBetbookProfileContext = () => useContext(BetbookProfileContext);

export const BetbookProfileProvider: FC<{ config: BetbookProfileContextConfig }> = ({ config, children }) => {
    // value is one pass time only, we do not propagate changes!
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const memoConfig = useMemo(() => config, []);
    return <BetbookProfileContext.Provider value={memoConfig}>{children}</BetbookProfileContext.Provider>;
};
